import type { IAffectedAppointment } from 'services/types/blockHours';

const MAX_LISTED = 5;

/**
 * Message shown after a time off was saved over booked appointments. Returns
 * null when there is nothing to warn about, so callers can skip the toast.
 * Shared by the single block-hour flow and the batch time-off flow.
 */
export const buildAffectedAppointmentsWarning = (
  affected?: IAffectedAppointment[] | null,
): string | null => {
  if (!affected?.length) return null;
  const lines = affected
    .slice(0, MAX_LISTED)
    .map(a => `${a.customerName?.trim() || a.customerPhone?.trim() || 'Customer'} — ${a.startTime}`);
  const more = affected.length - lines.length;
  const head = affected.length === 1
    ? '1 appointment falls inside this time off. Please reassign it:'
    : `${affected.length} appointments fall inside this time off. Please reassign them:`;
  return [head, ...lines, more > 0 ? `+${more} more` : ''].filter(Boolean).join('\n');
};
